<template>
  <body>
  <div style="width: 100%; background-color: rgba(0, 0, 0, 0)">
    <img
        style="
          height: 100vh;
          width: 100vw;
          overflow: hidden;
          position: absolute;
        "
        :src="require(`@/assets/RegisterNew/bgp0${randomPic}.jpg`)"
    />
    <span id="actionFrameId">
         <!--重置密码作框，流程1-->
        <div v-if="registerStep == 1" class="actionFrame">
          <div class="logo">
            <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
          </div>
          <div class="titleCtn">
            <div class="title-1">重置密码</div>
          </div>
          <!--手机号-->
          <div class="input-ctn" style="margin-top: 50px">
            <v-text-field
                v-model="telephone"
                label="手机号"
                placeholder="请输入手机号"
                outlined
                @blur="checkPhone"
            >
              <template v-slot:prepend-inner>
                <div style="width:35px;padding-top: 3px;padding-bottom:2px;border-right: solid 1px rgba(0, 0, 0, 0.25);color:rgba(0, 0, 0, 0.35) ">
                  +86
                </div>
              </template>
            </v-text-field>
          </div>
          <!--图片验证码-->
          <div class="input-ctn" style="margin-top: 15px">
           <div class="verifyInputCtn" style="margin-right: 5px">
                <v-text-field
                    v-model="verifyCode"
                    label="图片验证码"
                    placeholder=" "
                    outlined
                >
                </v-text-field>
            </div>
            <div class="verifyInputCtn" style="width: 190px;cursor:pointer;position: relative;" @click="captchaImage">
                <img :src="imgBase64" alt="" style="position: absolute;width: 190px;height: 60px;">
            </div>
          </div>
          <!--短信验证码-->
          <div class="input-ctn" style="margin-top: 15px">
            <v-text-field
                v-model="accessCode"
                label="短信验证码"
                placeholder="请输入短信验证码"
                outlined
                @blur="ifCanRegister"
            >
              <template v-if="registerStep == 1" v-slot:append>
                <v-fade-transition leave-absolute>
                  <div @click="clickSendCode" :class="canSendAgain ? 'getAccessCode':'getAccessCode-disabled'" >
                    {{countDown}}
                  </div>
                </v-fade-transition>
              </template>
            </v-text-field>
          </div>
          <!--点击下一步-->
          <div
              @click="clickNestStep"
              :class="registerAllow ? 'operateButton' : 'operateButton_disabled'"
              style="margin-top: 45px"
          >
            下一步
          </div>
          <!--底部文字-->
          <div class="text-ctn" style="margin-top: 40px">
            返回<span @click="$router.push('/Login')" style="color: #006699;cursor:pointer;">登录</span>
          </div>
          <div class="text2-ctn" style="font-size: 14px">
            Copyright © 2023-2026 长光卫星技术股份有限公司
            <a
                target="_blank"
                href="/PrivacyPolicy"
                @click.stop
                style="text-decoration: none; color: #979797"
            >
              · 隐私政策
            </a>
            <a
                target="_blank"
                href="/ServiceAgreement"
                @click.stop
                style="text-decoration: none; color: #979797"
            >
              · 服务协议</a
            >
          </div>
          <!--错误提示-->
          <div v-if="showAlert" class="alertCtn">
            {{ alertTip }}
            <img
                class="closeAlert"
                @click="showAlert = false"
                src="../assets/RegisterNew/关闭提示内容.png"
                height="22"
                width="22"
            />
          </div>
        </div>
      <!--重置密码，流程2-->
        <div v-if="registerStep == 2" class="actionFrame">
          <div class="logo">
            <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
          </div>
          <div class="titleCtn">
            <div class="title-1">重置密码</div>
          </div>
          <!--设置密码-->
          <div class="input-ctn" style="margin-top: 55px">
            <v-text-field
                v-model="password1"
                label="设置密码*"
                placeholder="限8-20位且包含大小写字母和数字"
                outlined
                :rules="[rules.passwordPattern]"
            >
            </v-text-field>
          </div>
          <!--再次输入密码-->
          <div class="input-ctn" style="margin-top: 25px">
            <v-text-field
                v-model="password2"
                label="再次输入密码*"
                placeholder=" "
                outlined
                :rules="[rules.password2Pattern]"
                @blur="ifCanResetPwd"
            >
            </v-text-field>
          </div>

          <!--点击重置密码-->
          <div @click="clickResetPwd"
               :class="
              certificationAllow ? 'operateButton' : 'operateButton_disabled'
            "
               style="margin-top: 70px"
          >
            重置密码
          </div>
          <!--底部文字-->
          <div class="text2-ctn" style="font-size: 14px">
            Copyright © 2023-2026 长光卫星技术股份有限公司
            <a
                target="_blank"
                href="/PrivacyPolicy"
                @click.stop
                style="text-decoration: none; color: #979797"
            >
              · 隐私政策
            </a>
            <a
                target="_blank"
                href="/ServiceAgreement"
                @click.stop
                style="text-decoration: none; color: #979797"
            >
              · 服务协议</a
            >
          </div>
          <!--错误提示-->
          <div v-if="showAlert" class="alertCtn">
            {{ alertTip }}
            <img
                class="closeAlert"
                @click="showAlert = false"
                src="../assets/RegisterNew/关闭提示内容.png"
                height="22"
                width="22"
            />
          </div>
        </div>
      <!--注册操作框，流程4,认证成功或失败-->
        <div v-if="registerStep == 3" class="actionFrame">
          <div class="logo">
            <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
          </div>

          <!--如果认证成功-->
          <div  class="detailInformationCtn2">
            <div class="text6-ctn" style="margin-top: 60px">
              <img
                  src="../assets/RegisterNew/认证成功.png"
                  height="44"
                  width="44"
              />
            </div>
            <div class="text6-ctn" style="margin-top: 30px; padding-left: 20px">
              修改密码成功！
            </div>
            <!--立即完善注册-->
            <div
                @click="$router.push('/Login')"
                class="operateButton"
                style="margin-top: 92px"
            >
              返回登录
            </div>

          </div>

          <!--底部文字-->
          <div class="text2-ctn" style="font-size: 14px">
            Copyright © 2023-2026 长光卫星技术股份有限公司
            <a
                target="_blank"
                href="/PrivacyPolicy"
                @click.stop
                style="text-decoration: none; color: #979797"
            >
              · 隐私政策
            </a>
            <a
                target="_blank"
                href="/ServiceAgreement"
                @click.stop
                style="text-decoration: none; color: #979797"
            >
              · 服务协议</a
            >
          </div>
          <!--错误提示-->
          <div v-if="showAlert" class="alertCtn">
            {{ alertTip }}
            <img
                class="closeAlert"
                @click="showAlert = false"
                src="../assets/RegisterNew/关闭提示内容.png"
                height="22"
                width="22"
            />
          </div>
        </div>
      </span>

  </div>
  </body>
</template>

<script>
import JSEncrypt from 'jsencrypt'
export default {
  name: "ForgetPassword",
  components:{
  },
  data() {
    return {

      password1:'',
      password2:'',
      verifyCode:'',//图片验证码
      verifyCodeTrue:false,//验证码是否正确
      // 图片验证码的随机取值范围
      identifyCodes: '1234567890',
      certifySuccess: false, //是否验证成功
      timeOutMantle: false, //二维码过期
      certificationAllow: false, //是否可以重置密码
      checkIdentifyResult: false, //身份证格式是否正确
      registerAllow: false,
      checkPhoneResult: "", //手机号码验证是否通过，通过为true，否则为字符串
      realName: "",
      IDCard: "",
      whyIdentifyTip: false, //实名认证原因提示框
      registerStep:1, //注册流程进行到的步骤，预计流程分为5步
      randomPic: 7, //1-7随机数，用于选择背景图片
      telephone: "", //手机号
      countDown: "获取验证码", //发送验证码，与再次发送倒计时
      canSendAgain: true, //可以发送验证码
      accessCode: "", //短信验证码
      read_checkbox: false, //已阅读并同意选择框
      alertTip: "请输入正确的手机号码",
      showAlert: false,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        phone: (value) => {
          const pattern = /^[0-9]{11}$/;
          if (value) {
            return pattern.test(value) || "请填写正确的手机号码";
          } else {
            return true;
          }
        },
        email: (value) => {
          const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (value) {
            return pattern.test(value) || "请填写正确的邮箱格式";
          } else {
            return true;
          }
        },
        passwordPattern: (value) => {
          const pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,20}$/;
          if (value) {
            return (
                pattern.test(value) ||
                "请填写正确的密码格式，要求为8-20位大小写字母和数字的组合"
            );
          } else {
            return true;
          }
        },
        password2Pattern: (value) => {
          if (value != this.password1) {
            return "请保持前后密码一致";
          } else {
            return true;
          }
        },
        notNull: (value) => {
          if (value == "" || value == null) {
            return "此项不能为空";
          } else {
            return true;
          }
        },
      },
      imgBase64:'',
      uuid:'',
      encrypted:''
    };
  },
  methods: {
    //识别屏幕缩放比例
    detectZoom(){
      var ratio = 0,
          screen = window.screen,
          ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      }
      else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      }
      else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth;
      }
      if (ratio){
        ratio = Math.round(ratio * 100);
      }
      return ratio;
    },
    //获取图片验证码
    captchaImage(){
      this.axios.get("/loginapi/captchaImage?type=resetPassword").then((res) => {
        if(res.data.code==200){
          this.imgBase64=res.data.data.img
          this.uuid=res.data.data.uuid
        }else{
          this.alertTip='获取图片验证码失败'
          this.showAlert=true
        }
      })
    },
    //点击重置密码
    clickResetPwd:function(){
      if(this.certificationAllow){
        let param = new FormData();
        param.append("phone", this.telephone);
        param.append("prefix", "");
        param.append("verifyCode", this.accessCode);
        param.append("password",this.password1)
        this.axios.post("/loginapi/checkCodeForResetPwdInLogin", param).then((res) => {
          console.log(res);
          let resData = res.data;
          if (resData.success == false) {
            this.alertTip = resData.message;
            this.showAlert = true;
          } else if (resData.success == true) {
            this.alertTip = "";
            this.showAlert = false;
            this.registerStep = 3;
          }
        });
      }

    },
    //检验是否可以重置密码
    ifCanResetPwd:function(){
      const pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,20}$/;
      if (this.password1 == this.password2) {
        if (!pattern.test(this.password1)) {
          this.alertTip = "请填写正确的密码格式";
          this.showAlert = true;
          this.certificationAllow=false;
          return;
        }
      } else {
        this.alertTip = "密码前后不一致";
        this.showAlert = true;
        this.certificationAllow=false;
        return;
      }
      this.certificationAllow=true;
      this.alertTip = "";
      this.showAlert = false;
    },
    //检验手机号码格式
    checkPhone:function(){
      let checkResult=this.phonePattern(this.telephone)
      this.checkPhoneResult=checkResult
      //如果手机号通过正则检验
      if(checkResult==true){
        //取消电话号码格式错误或验证码错误提示
        this.alertTip='';
        this.showAlert=false;
      }
      else {
        this.alertTip=checkResult;
        this.showAlert=true;
      }
    },
    //点击下一步
    clickNestStep: function () {
      if (this.registerAllow) {
        let param = new FormData();
        param.append("phone", this.telephone);
        param.append("prefix", "");
        param.append("verifyCode", this.accessCode);
        this.axios.post("/loginapi/checkCodeForResetPwd", param).then((res) => {
          console.log(res);
          let resData = res.data;
          if (resData.success == false) {
            this.alertTip = resData.message;
            this.showAlert = true;
          } else if (resData.success == true) {
            this.alertTip = "";
            this.showAlert = false;
            this.registerStep = 2;
          }
        });
      }
    },
    //判断是否可以注册
    ifCanRegister: function () {
      if (
          this.checkPhoneResult == true &&
          this.accessCode.length > 1 &&
          this.verifyCode!=''
      ) {
        this.registerAllow = true;
      } else {
        this.registerAllow = false;
      }
    },
    //验证手机格式
    phonePattern: function (phone) {
      const pattern = /^[0-9]{11}$/;
      if (phone) {
        return pattern.test(phone) || "请填写正确的手机号码";
      } else {
        return "请填写正确的手机号码";
      }
    },
    //点击获取验证码
    clickSendCode: function () {
      let checkResult = this.phonePattern(this.telephone);
      this.checkPhoneResult = checkResult;
      //如果手机号通过正则检验
      if (checkResult == true) {
        //取消电话号码格式错误提示
        this.alertTip = "";
        this.showAlert = false;
        if (this.canSendAgain) {
          //立即禁用按钮，防止重复点击
          this.canSendAgain=false;
          //调用发送验证码的函数
          this.sendCode();
        }
      } else {
        this.alertTip = checkResult;
        this.showAlert = true;
      }
    },
    //json加密
    RSA_encryption(jsonData){
      var PUBLIC_KEY='MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2i8ZSgjf9ARRHRC/fFlGlWV6j6z78//8YlxGlAOq4a4tNS/Da35mfwkPM1qa7lr9dwjmT5CwTJVuHoUfsA5CmMHi+x+9vF5eyy62m1/yv8zgIwdQEaD0SLjDrnzqhM9k/vxpWR/d64rz6zUEwbYJM7NgNohlg3vqBYZlTJL7t5/145+CnSzmhIaeBl4sbAulFydGTqDWvzvfR6Y9eBQUQjyEyLom1vS4piq2OYAKVkX1ozo05xt49mD9eUYdDfHlxOsbPl8DwXpxl2XiJR3+vXkNIFKTdPTSYKR3Gh17sQelX+GwF0nixCAaqplUnw+/FVBmtBkih/eplGTQ8f5mDwIDAQAB'
      var encrypt = new JSEncrypt()
      encrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + PUBLIC_KEY + '-----END PUBLIC KEY-----')
      var encrypted = encrypt.encrypt(JSON.stringify(jsonData))
      this.encrypted=encrypted
    },
    //发送验证码函数
    sendCode: function () {
      var json={
        "phone": this.telephone,
        "uuid": this.uuid,
        "code": this.verifyCode
      }
      this.RSA_encryption(json)
      this.axios.post("/loginapi/resetPasswordVerify",this.encrypted,{
        headers: {
          'Content-Type': "application/json;charset=utf-8",
        },
      }).then((res)=>{
        let resData=res.data;
        if(resData.success==false){
          //失败时恢复按钮状态，允许用户重试
          this.canSendAgain=true;
          this.alertTip=resData.message;
          this.showAlert=true;
          if(resData.code==50008){
            this.captchaImage()
          }
        }else{
          this.sendAgainCountDown();
        }
      })
    },
    //发送倒计时
    sendAgainCountDown: function () {
      let t = 60;
      this.canSendAgain = false;
      let timer = setInterval(() => {
        this.countDown = "重新发送 (" + t + "s)";
        t--;
        if (t < 0) {
          this.canSendAgain = true;
          this.countDown = "获取验证码";
          clearInterval(timer);
        }
      }, 1000);
    },
  },
  mounted() {
    this.captchaImage()
    //屏幕适应问题
    let screenZoom=this.detectZoom() //屏幕放大倍数
    let screenWidth=window.screen.width
    let divFrame = document.getElementById("actionFrameId");
    if(screenWidth<2500){
      divFrame.setAttribute("style","zoom:"+(100-(screenZoom-100)/1.8).toFixed(2).toString()+"%");
    }
  },
  created() {
    this.randomPic = Math.floor(Math.random() * 7 + 1);
  },
  watch: {

  },
};
</script>

<style scoped>
.verifyInputCtn{
  width:300px;
  height:60px;
  float:left;
}

.text6-ctn {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  text-align: center;
}

.detailInformationCtn2 {
  position: absolute;
  top: 130px;
  left: 0px;
  width: 620px;
  height: 479px;
}

.text4-ctn {
  margin-top: 79px;
  margin-left: 65px;
  width: 200px;
  height: 17px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3a3a3a;
  line-height: 17px;
  cursor: pointer;
}
.text3-ctn {
  position: relative;
  margin-left: 231px;
  margin-top: 15px;
  width: 158px;
  height: 24px;
  background: #f5f5f6;
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
}

.text2-ctn {
  position: absolute;
  bottom: 33px;
  left: 65px;
  width: 499px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #979797;
  line-height: 17px;
}
.text-ctn {
  margin-left: 62px;
  width: 500px;
  height: 20px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 20px;
}
.operateButton2 {
  margin-left: 60px;
  width: 500px;
  height: 54px;
  line-height: 54px;
  border: 1px solid #006699;
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #006699;
  cursor: pointer;
}
.operateButton {
  margin-left: 60px;
  width: 500px;
  height: 54px;
  line-height: 54px;
  background: #006699;
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}
.operateButton_disabled {
  margin-left: 60px;
  width: 500px;
  height: 54px;
  line-height: 54px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}
.getAccessCode {
  width: 150px;
  margin-top: 5px;
  /*height: 40px;*/
  /*line-height: 40px;*/
  text-align: right;
  padding-right: 10px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #006699;
  cursor: pointer;
}
.getAccessCode-disabled {
  width: 150px;
  margin-top: 5px;
  /*height: 40px;*/
  /*line-height: 40px;*/
  text-align: right;
  padding-right: 10px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #979797;
  cursor: pointer;
}
.purposeArea {
  float: left;
  width: 240px;
  height: 60px;
}
.input-ctn {
  width: 500px;
  height: 60px;
  margin-left: 60px;
}
.title-1 {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 28px;
  border-bottom: 3px solid #006699;
}

.titleCtn {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 35px;
  margin-top: 85px;
}
.logo {
  position: relative;
  top: 58px;
  left: 174px;
  width: 272px;
  height: 44px;
  text-align: center;
  padding-right: 10px;
  font-size: 30px;
}
.closeAlert {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
}
.alertCtn {
  position: absolute;
  top: -94px;
  left: 0px;
  width: 620px;
  height: 54px;
  line-height: 54px;
  background: #ff4040;
  border-radius: 8px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
}
.actionFrame {
  position: absolute;
  top: 190px;
  left: 50%;
  margin-left: -310px;
  width: 620px;
  height: 660px;
  background: #ffffff;
  border-radius: 16px;
}
</style>
